export const dashboardNumberInputHook = 'dashboard-number-input';
